import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import DashboardLayout from '../../components/DashboardLayout';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { HomeworkItem, EmptyHomework } from '../../components/HomeworkItem';
import { ClipboardList, ChevronDown, ChevronRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const twoWeeksAgo = () => { const d = new Date(); d.setDate(d.getDate() - 14); return d.toISOString().slice(0, 10); };

const ChildHomework = ({ k }) => {
    const [showOld, setShowOld] = useState(false);
    const [open, setOpen] = useState(true);
    const cutoff = twoWeeksAgo();
    const recent = k.items.filter(h => h.date >= cutoff);
    const older = k.items.filter(h => h.date < cutoff);
    const shown = showOld ? k.items : recent;
    return (
        <Card className="card-surface overflow-hidden" data-testid={`hw-child-${k.student_id}`}>
            <button className="w-full flex items-center gap-3 px-4 py-3 bg-[#064E3B]/5 hover:bg-[#064E3B]/10 text-left" onClick={() => setOpen(o => !o)} data-testid={`hw-child-toggle-${k.student_id}`}>
                {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                <span className="font-semibold text-[#064E3B] font-['Outfit']">{k.name}</span>
                {k.class_name && <span className="text-xs text-[#6B7280]">{k.class_name}</span>}
                <Badge variant="outline" className="ml-auto">{k.items.length} homework</Badge>
            </button>
            {open && <CardContent className="p-0">
                {shown.length === 0 ? <EmptyHomework text={older.length ? 'No homework in the last two weeks.' : 'No homework yet.'} /> : <div className="divide-y">{shown.map(h => <HomeworkItem key={h.id} h={h} showTarget={false} showTeacher />)}</div>}
                {older.length > 0 && <div className="p-3 border-t bg-[#FAF9F6] text-center"><Button size="sm" variant="outline" onClick={() => setShowOld(s => !s)} data-testid={`hw-show-older-${k.student_id}`}>{showOld ? 'Show latest only' : `Show older (${older.length})`}</Button></div>}
            </CardContent>}
        </Card>
    );
};

const ParentHomework = () => {
    const { user } = useAuth();
    const [data, setData] = useState(null);
    useEffect(() => { axios.get(`${API_URL}/api/homework/my`, { withCredentials: true }).then(r => setData(r.data)).catch(() => setData([])); }, [user?.id]);
    const total = useMemo(() => (data || []).reduce((n, k) => n + k.items.length, 0), [data]);
    return (
        <DashboardLayout>
            <div className="space-y-6" data-testid="homework-page">
                <div><h1 className="text-2xl font-bold text-[#1F2937] font-['Outfit'] flex items-center gap-2"><ClipboardList className="h-6 w-6 text-[#5B21B6]" />Homework</h1>
                    <p className="text-[#4B5563]">Homework set by your children's teachers — newest first{total ? ` · ${total} in total` : ''}</p></div>
                {data === null ? <p className="text-sm text-[#6B7280]">Loading…</p> : data.length === 0 ? <Card className="card-surface"><EmptyHomework text="No active students linked to your account." /></Card>
                    : data.map(k => <ChildHomework key={k.student_id} k={k} />)}
            </div>
        </DashboardLayout>
    );
};

export default ParentHomework;
